export default "__VITE_PUBLIC_ASSET__ca26435e__"